import { lazyRoute } from "@/routes/lazy-route";

const PhaseSettingsPage = lazyRoute(() => import("./phase-settings.page"), "PhaseSettingsPage");

export const phaseSettingsRoutes = [
  {
    path: "phase",
    element: <PhaseSettingsPage />,
  },
];
